function validateRestaurant(data) {
  const errors = [];
  if (!data.restaurant_name) errors.push('Restaurant name is required');
  if (!data.address) errors.push('Address is required');
  if (!data.contact_number) errors.push('Contact number is required');
  if (data.radius_of_service && data.radius_of_service <= 0) errors.push('Radius of service must be positive');
  if (data.minimum_order_amount && data.minimum_order_amount <= 0) errors.push('Minimum order amount must be positive');
  if (data.geolocation && (!data.geolocation.latitude || !data.geolocation.longitude)) {
    errors.push('Geolocation must include latitude and longitude');
  }
  return errors;
}

function validateMenu(data) {
  const errors = [];
  if (!data.restaurant_id) errors.push('Restaurant ID is required');
  if (!data.category) errors.push('Category is required');
  if (!data.menu_data || !data.menu_data.length) errors.push('At least one menu item is required');
  data.menu_data.forEach((item, index) => {
    if (!item.name) errors.push(`Menu item ${index + 1}: Name is required`);
    if (!item.portions || !item.portions.length) errors.push(`Menu item ${index + 1}: At least one portion is required`);
    item.portions.forEach((portion, pIndex) => {
      if (!portion.size) errors.push(`Menu item ${index + 1}, Portion ${pIndex + 1}: Size is required`);
      if (portion.price <= 0) errors.push(`Menu item ${index + 1}, Portion ${pIndex + 1}: Price must be positive`);
    });
  });
  return errors;
}

function validateImages(restaurant_staging_id, files) {
  const errors = [];
  if (!restaurant_staging_id) errors.push('Restaurant ID is required');
  if (!files || files.length === 0) errors.push('At least one image is required');
  return errors;
}

module.exports = { validateRestaurant, validateMenu, validateImages };